import { configureStore } from '@reduxjs/toolkit';
import authReducer from './features/auth/authSlice';
import membersReducer from './features/members/membersSlice';
import giveawaysReducer from './features/giveaways/giveawaysSlice';
import ticketsReducer from './features/tickets/ticketsSlice';
import statsReducer from './features/stats/statsSlice';
import emailsReducer from './features/emails/emailsSlice';
import notificationsReducer from './store/slices/notificationsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    members: membersReducer,
    giveaways: giveawaysReducer,
    tickets: ticketsReducer,
    stats: statsReducer,
    emails: emailsReducer,
    notifications: notificationsReducer,
  },
});